import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const PRICE = /(\d[\d\s.,]*\s*₼\S*)/;
const manat = (p) => p.split("₼").flatMap((x, i) => (i ? [<span key={i} className="manat">₼</span>, x] : [x]));

export function useWebPrice() {
  const { config } = useSite();
  return (config.contacts?.price_badge || "").match(/\d[\d\s.,]*\s*₼/)?.[0] || "";
}

export const Manat = ({ text }) => <>{manat(text)}</>;

export default function PriceBadge({ className = "" }) {
  const { config } = useSite();
  const text = config.contacts?.price_badge;
  const to = config.calc?.enabled ? "/#calculator" : "/#contact";
  if (!text) return null;
  const [before, price, after] = text.split(PRICE);
  return (
    <Link to={to} className={`price-badge fade-up text-sm sm:text-[15px] text-[#2d2c29] ${className}`} data-testid="hero-price-badge">
      <span className="w-8 h-8 shrink-0 rounded-full bg-[#171715] text-[#F3D592] flex items-center justify-center"><Sparkles size={15} /></span>
      <span>
        {before}
        {price && <span className="pb-chip pb-shine mx-1" data-testid="hero-price-value"><span className="num">{manat(price)}</span></span>}
        {after}
      </span>
      <ArrowRight size={16} className="pb-arrow shrink-0 text-[#171715]/60" />
    </Link>
  );
}
